export const ROLE = "role";
export const RESOURCE_NAME = "resourceName";
export const SCHOOL_ID = "schoolId";
export const REGION_HEAD_ID = "regionHeadId";
export const RELATIONSHIP_MANAGER_ID = "relationshipManagerId";
export const CRM_OPS_STATUS = "crmOpsStatus";
export const COMMENT = "comment";
export const TARGET_DATE = "targetDate";
export const NO_OF_WORKSTATIONS = "noOfWorkstations";
export const SPECIAL_REQUIREMENTS = "specialRequirements";
export const LAB_SETUP_STATUS = "labSetupStatus";

export const roleOptions = [
  { label: "Region Head", value: "region_head" },
  { label: "Relationship Manager", value: "relationship_manager" },
];



export const labSetupStatusOptions = [
  { label: "To Do", value: "To-Do" },
  { label: "On Track", value: "On Track" },
  { label: "Delayed", value: "Delayed" },
  { label: "Lab Done", value: "Lab Done" },
  { label: "Stocking Done", value: "Stocking Done" },
];